// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  fromPlayer: __t.identity().name("from_player"),
  toPlayer: __t.identity().name("to_player"),
  status: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  resolvedAt: __t.option(__t.timestamp()).name("resolved_at"),
});
